module.exports = __webpack_public_path__ + "Roboto-Bold.39b2c3031be6b4ea96e2.woff2";


//////////////////
// WEBPACK FOOTER
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/src/font/roboto/Roboto-Bold.woff2
// module id = ../../../../../src/font/roboto/Roboto-Bold.woff2
// module chunks = 1